import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InlineSVGModule } from 'ng-inline-svg';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { NumberToWordsPipe } from '../pipes/numberToWords.pipe';
import { ShortenPipe } from '../pipes/shorten.pipe';
import { NgxBarcodeModule } from 'ngx-barcode';
import { WebcamModule } from 'ngx-webcam';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TimeFormatPipe } from '../pipes/timeFormat.pipe';


export const MY_FORMATS = {
	parse: {
	  dateInput: 'LL',
	},
	display: {
	  dateInput: 'LL',
	  monthYearLabel: 'MMM YYYY',
	  dateA11yLabel: 'LL',
	  monthYearA11yLabel: 'MMMM YYYY',
	},
  };
  
@NgModule({
  declarations: [
	  NumberToWordsPipe,
	  ShortenPipe,
	  TimeFormatPipe,
  ],
  imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatIconModule,
		MatTooltipModule,
		MatButtonModule,
		MatSortModule,
		MatPaginatorModule,
		MatTableModule,
		MatDatepickerModule,
		MatInputModule,
		MatRadioModule,
		MatSelectModule,
		MatCheckboxModule,
		NgbModule,
		// BrowserAnimationsModule,
		MatToolbarModule,
		MatButtonToggleModule,
		InlineSVGModule,
		MatChipsModule,
		DragDropModule,
		NgxDaterangepickerMd.forRoot(),
		MatDialogModule,
		MatProgressSpinnerModule,
		MatAutocompleteModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatMenuModule,
		NgxBarcodeModule ,
		ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
		WebcamModule,
		MatTabsModule,
		MatSidenavModule
		// MAT_DIALOG_DEFAULT_OPTIONS,
  ],
  exports: [
    MatFormFieldModule,
		MatIconModule,
		MatTooltipModule,
		MatButtonModule,
		MatSortModule,
		MatPaginatorModule,
		MatTableModule,
		MatDatepickerModule,
		MatInputModule,
		MatRadioModule,
		MatSelectModule,
		MatCheckboxModule,
		NgbModule,
		// BrowserAnimationsModule,
		MatToolbarModule,
		MatButtonToggleModule,
		InlineSVGModule,
		MatChipsModule,
		DragDropModule,
		MatProgressSpinnerModule,
		MatAutocompleteModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatMenuModule,
		NgxBarcodeModule,
		WebcamModule,
		MatTabsModule,
		MatSidenavModule,
		ShortenPipe,
		TimeFormatPipe
  ],

  providers: [

	{
		provide: MAT_DIALOG_DEFAULT_OPTIONS,
		useValue: {
			hasBackdrop: true,
			panelClass: 'kt-mat-dialog-container__wrapper',
			height: 'auto',
			width: '900px'
		}
	},
	 {
		provide: DateAdapter,
		useClass: MomentDateAdapter,
		deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
	  },
  
	  {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
]
})
export class MaterialModule { }
